import { Alert } from "../../../.."
import Ajax from "../../../../Ajax"
import { attributeKeys } from "../../../../misc/AttributeKeys"
import { DataSource, Questionnaire } from "../../../../models/Interfaces"
import { store } from "../../../../stores/Store"


export const getMergeSources = async (automationId: string, enquiryUid: string, questionnaireUids: string[]) => {

    var { getQuestionnaireList, setMergedDependants, setMergeOverride } = store.QuestionnaireStore

    var sources = []
    var subjectChildDependants = []
    var dataSourceRefs = []
    var accountRef = [...store.NodeStore.breadcrumb].reverse().find(nr => nr.uid.includes("ACCOUNT"))
    var mergeOverride = {}
    var enquirySubjectPrefix = getQuestionnaireAnswersSubjectPrefix(automationId, "SWV_JA")

    // Get Questionnaire data
    await getQuestionnaireList(questionnaireUids).then((qArray) => {
        for (var i = 0; i < qArray.length; i += 1) {
            var que: Questionnaire = qArray[i]
            que.answers.label = `${que.template.displayName}, ${que.displayName}`
            que.answers.iconId = i
            var subjectPrefix = getQuestionnaireAnswersSubjectPrefix(automationId, que.template.key)
            console.log(automationId, que.template.key, subjectPrefix)

            // Handle child dependants
            if (subjectPrefix.startsWith("subject_child")) {
                subjectChildDependants.push({...que.answers})
                dataSourceRefs.push(new DataSource(que.uid, "Questionnaire", que.answers.label, que.template.key))
                mergeOverride = {...mergeOverride, subject_applying_with_dependants: "true", subject_applying_with_children: "true"}
                continue
            }

            if (subjectPrefix.startsWith("subject_partner")) {
                mergeOverride = {...mergeOverride, subject_applying_with_dependants: "true", subject_applying_with_partner: "true"}
            }

            if (subjectPrefix.startsWith("subject_partner") || subjectPrefix.startsWith("subject_supporter")) {
                var newAnswers = {}

                // Itterate through answers adding them to newAnswers
                Object.keys(que.answers).filter(fieldName => !keysToSkipForDepentants.includes(fieldName)).forEach((fieldName) => {
                    // Reformat field key
                    var newFieldName = fieldName.startsWith("subject") ? fieldName.replace("subject", subjectPrefix) : fieldName
                    var fieldValue = que.answers[fieldName]
                    newAnswers[newFieldName] = fieldValue
                })
                que.answers = newAnswers
            }

            sources.push({...que.answers})
            dataSourceRefs.push(new DataSource(que.uid, "Questionnaire", que.answers.label, que.template.key))
        }
    })

    // Get Assessment and Advisor data
    await Ajax.Automation.GetAssessmentData(accountRef?.uid, enquiryUid, enquirySubjectPrefix).then((response) => {
        sources.push({...response.data, iconId: "aora", label: "AORA data"})
        if (enquiryUid) {
            dataSourceRefs.push(new DataSource(enquiryUid, "Assessment", enquiryUid.replace("ENQUIRY_", "Assessment ")))
        }
    }).catch((response) => {
        Alert({message: response.data?.detail ? response.data.detail : "Couldn't load enquiry data"})
    })
    
    setMergeOverride({...mergeOverride, data_source_refs: dataSourceRefs})

    if (subjectChildDependants.length) {
        // Remove any potential conflicts
        sources.filter(source => "subject_child_dependants" in source).forEach(source => {
            delete source.subject_child_dependants
        })
        sources.push({"subject_child_dependants": subjectChildDependants})
        setMergedDependants(subjectChildDependants)
    }
    return sources
}

export const getQuestionnaireAnswersSubjectPrefix = (automationId: string, questionnaireTemplateKey: string) => {
    if (automationId.includes("SWV")) {
        if (questionnaireTemplateKey.includes("DEP_PARTNER")) {
            return "subject_partner"
        }

        if (questionnaireTemplateKey.includes("DEP_CHILD")) {
            return "subject_child"
        }
    }
    if (automationId.includes("DEP")) {
        if (questionnaireTemplateKey.includes("SWV")) {
            return "subject_supporter"
        }
    }
    return "subject"
}


// Sort using KeyOrder
export const sortKeys = (keys) => {
    var newlist = []
    Object.keys(attributeKeys).filter(ko => keys.includes(ko)).forEach(ko => {
        newlist.push(ko)
    })
    // Any keys with no defined order will be lumped together alphabetically at the and.
    keys.filter(key => !newlist.includes(key)).sort((a,b) => a.localeCompare(b)).forEach(key => {
        newlist.push(key)
    })
    newlist = [...new Set(newlist)].filter(key => !keysToIgnore.includes(key))
    return newlist
}


export const formatValue = (key, value) => {

    if (value === "true" || value === "false") {
        return value.replace("true", "Yes").replace("false", "No")
    }

    if ((key.includes("country") || key.includes("applying_from")) && value in store.AppStore.displayDictionaries.countries_of_birth) {
        return store.AppStore.displayDictionaries.countries_of_birth[value]
    }

    return value
}


export const formatFieldKey = (key) => {
    if (key.startsWith("subject")) {
        key = key.replace("subject", "applicant")
    }
    if (key.startsWith("advisor")) {
        key = key.replace("advisor", "adviser")
    }
    key = String(key).charAt(0).toUpperCase() + String(key).slice(1)
    return key.replaceAll("_", " ")
}


export const keysToIgnore = [
    "submitted_pages",
    "label",
    "iconId",
    "uid",
    "settings_confirmed",
    "confirm_information",
    "enter_applicant_info",
    "enter_security_info",
    "percentage_complete",
    "priority_service_selected",
    "data_sources",
    "data_source"
]

export const keysToSkipForDepentants = [
    "applying_from",
    "family_in_uk",
    "immigration_rejections",
    "UK_immigration_law_breaches",
    "uk_ltr_applications",
    "world_travel_history",
    "subject_world_travel_history",
    "security_question_set_1",
    "security_question_first_school",
    "security_question_wedding_city",
    "security_question_first_job",
    "security_question_favourite_teacher",
    "security_question_parents_met",
    "security_question_set_2",
    "security_question_location_born",
    "security_question_first_street_name",
    "security_question_dream_job",
    "security_question_partner_name",
    "security_question_first_pet",
    "security_question_set_3",
    "security_question_favourite_film",
    "security_question_partner_mother",
    "security_question_father_birthplace",
    "security_question_first_car",
    "security_question_eldest_sibling",
]

export const updatableFieldNames = [
    "subject_email",
    "subject_phone",

    "advisor_phone",
	"advisor_first_name",
    "advisor_family_name",
	"advisor_address_line_1",
    "advisor_city",
	"advisor_post_code",

	"advisor_email",
	"advisor_organisation",
	"advisor_regulation_number",
]